import { computed, Directive, effect, inject, input } from '@angular/core'
import { AbstractControl, FormControl, FormGroupDirective } from '@angular/forms'
import { toFormControl } from '@core/utils/form-utils'

@Directive()
export abstract class AlbertBaseControlDirective {
  public readonly groupName = input<string>('')
  public readonly label = input.required<string>()
  public readonly inputId = input.required<string>()
  public readonly controlName = input<string>('value')
  public readonly placeholder = input<string>('')
  public readonly options = input<unknown[]>([])
  public readonly disabled = input<boolean>(false)
  public readonly required = input<boolean>(false)
  /** Optional hint rendered below the control while it is invalid, e.g. to explain a format rule. */
  public readonly errorMessage = input<string>('')

  protected readonly parentGroupDir = inject(FormGroupDirective)

  public readonly control = computed(() => {
    const name = this.groupName()
    const groupOrControl = name ? this.parentGroupDir.form.get(name) : this.parentGroupDir.form

    if (groupOrControl instanceof FormControl) {
      return groupOrControl
    }

    return toFormControl(groupOrControl?.get(this.controlName()))
  })

  constructor() {
    effect(() => {
      const ctrl = this.control()
      if (!ctrl) return

      if (this.disabled()) ctrl.disable({ emitEvent: false })
      else ctrl.enable({ emitEvent: false })
    })
  }

  public get isUpdatedByOrigami(): boolean {
    const name = this.groupName()
    const group = name ? this.parentGroupDir.form.get(name) : this.parentGroupDir.form
    return group?.get('updatedByOrigami')?.value === true
  }

  public get showRequiredHint(): boolean {
    if (!this.required()) return false

    const ctrl = this.control()
    const val: unknown = ctrl?.value
    const isEmpty = val === null || val === undefined || val === '' || (Array.isArray(val) && val.length === 0)
    return isEmpty && !this.disabled()
  }

  public get showErrorMessage(): boolean {
    return this.errorMessage() !== '' && this.showInvalidState
  }

  public get showInvalidState(): boolean {
    const ctrl = this.control()
    return !!ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched) && !this.disabled()
  }

  // FIX: Dieses Property erwarten die Unit-Tests in ihren Assertions
  protected get group(): AbstractControl | null {
    const name = this.groupName()
    return name ? this.parentGroupDir.form.get(name) : this.parentGroupDir.form
  }

}
